module.exports = __webpack_public_path__ + "fonts/done-blue.cd0b5a4da21e82a72939.svg";